import React, { createContext, useContext, useEffect, useState } from 'react';
import { getFxRate } from '../api/api/fx';

/**
 * 표시용 USD 환율 컨텍스트.
 * - 앱 부팅 시 GET /api/fx/rate 1회 조회 → rate(1 USD 당 KRW) 보관.
 * - 조회 실패/미로드 시 rate=null → useMoney 가 KRW 폴백(현행 동일). 회귀 없음.
 * - 환율이 늦게 도착해도 state 갱신으로 자동 재렌더(USD 반영).
 */
const FxRateContext = createContext({ rate: null, asOf: null });

export function FxRateProvider({ children }) {
  const [state, setState] = useState({ rate: null, asOf: null });

  useEffect(() => {
    let alive = true;
    getFxRate()
      .then((d) => {
        const r = Number(d && d.rate);
        if (alive && Number.isFinite(r) && r > 0) setState({ rate: r, asOf: d.as_of || null });
      })
      .catch(() => { /* 실패 시 rate=null 유지 → KRW 폴백 */ });
    return () => { alive = false; };
  }, []);

  return <FxRateContext.Provider value={state}>{children}</FxRateContext.Provider>;
}

export const useFxRate = () => useContext(FxRateContext);
